<template>
  <div>
    <!-- <div v-if="renderComponent"> -->
    <!--    <template>-->
    <!--      <binary-odds-->
    <!--        v-for="(runner, i) in runners"-->
    <!--        :key="`odds-${runner.id + i}`"-->
    <!--        :market="market"-->
    <!--        :one-market="market[i]"-->
    <!--        :runner="runner"-->
    <!--      ></binary-odds>-->
    <!--    </template>-->
    <template>
      <binary-odds
        v-for="(mark, i) in market"
        :key="`odds-${mark.id + mark.runners[0].id + i}`"
        :market="market"
        :one-market="market[i]"
        :runner="mark.runners[0]"
      ></binary-odds>
    </template>
    <!-- <template>
      <fancy-inner-odds
        v-for="runner in runners"
        :key="`odds-${runner.betfairId}`"
        :market="market"
        :runners="runner"
        :max-commission="maxCommission"
      ></fancy-inner-odds>
    </template> -->

    <!-- </div> -->

    <ladder-overlay></ladder-overlay>
  </div>
</template>
<script>
import BinaryOdds from '@/components/BinaryOdds'
// import FancyInnerOdds from '@/components/FancyInnerOdds'
import LadderOverlay from '@/components/LadderOverlay'

export default {
  name: 'FancyOdds',
  components: {
    LadderOverlay,
    // FancyInnerOdds
    BinaryOdds
  },
  props: {
    market: { type: Array, default: () => [], required: false },
    maxCommission: { type: Number, required: false },
    runners: { type: Array, default: () => [], required: true }
  },
  data() {
    return {
      fancyRunners: []
      // renderComponent: true
    }
  },
  created() {
    // Fetch Fancy every 10 seconds
    // setInterval(async () => {
    //   await this.$store.dispatch('matchInside/getFancy', {
    //     market: this.$route.params.id
    //   })
    //   this.renderComponent = false
    //   await this.$nextTick()
    //   this.renderComponent = true
    //   await this.$store.dispatch('socketCustomerService/joinRooms', {
    //     socketId: socket.id,
    //     gameId: this.$route.params.id
    //   })
    // }, 10000)
    // Fetch Fancy every 10 seconds
    // console.log('maaaa', this.market)
    // console.log('raaaa', this.runners)
  },
  beforeDestroy() {},
  methods: {
    reject(array, key, id) {
      const removeIndex = array.map((item) => item[key]).indexOf(id)
      if (removeIndex >= 0) {
        array.splice(removeIndex, 1)
      }
      return array
    }
  }
}
</script>
<style lang="scss" scoped>
.opacity-0 {
  opacity: 0;
}
</style>
